import React from "react";

const Award = () => {
	return (
		<section className="page__award award">
			<div className="award__wrapper">
				<h2 className="award__title">
					Give <span className="title--line">certificates</span> to participants
				</h2>

				<p className="award__description">
					The jury of the competition will consider the works and select the
					winners by city and age category, as well as determine other
					nominations, emphasizing the unique feature of each particular drawing
					- all children will receive diplomas!
				</p>
				<p className="award__description">
					It will be possible to download the diploma in your personal account
					one day after the end of the competition, we will additionally send it
					to e-mail.
				</p>
				<p className="award__description">
					With an elephant to victories ahead!
				</p>
			</div>

			<div className="award__diploma diploma">
				<div className="diploma__wrapper">
					<div className="diploma__desc">
						<h2 className="diploma__title">Diploma</h2>
						<h3 className="diploma__subtitle">Awarded</h3>
						<h4 className="diploma__respondent">Gwen Gray</h4>
						<div className="diploma__seporater"></div>
						<h5 className="diploma__description">1 place</h5>
						<p className="diploma__text">
							in the All-Nation competition of children's drawings
							<br />
							«My happy summer» <br />
							Age from 0 to 4 years, Denver
						</p>
					</div>

					<div className="diploma__details">
						<p className="diploma__logo-text">
							El<span className="diploma__logo-detail">Smart</span>
						</p>
						<p className="diploma__date">15.08.2022</p>
						<img
							className="diploma__print"
							src="./img/award/print.png"
							alt="Print image"
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Award;
